__turbopack_context__.v({
  "item": "OverlayResourceDisclosure-module__P6zTgq__item",
  "link": "OverlayResourceDisclosure-module__P6zTgq__link",
  "list": "OverlayResourceDisclosure-module__P6zTgq__list",
  "panel": "OverlayResourceDisclosure-module__P6zTgq__panel",
  "root": "OverlayResourceDisclosure-module__P6zTgq__root",
  "trigger": "OverlayResourceDisclosure-module__P6zTgq__trigger",
  "triggerActive": "OverlayResourceDisclosure-module__P6zTgq__triggerActive",
});
